import { Outlet } from 'react-router-dom';
import NavbarCommercial from './NavbarCommercial';

const CommercialLayout = () => {
  return (
    <>
      <NavbarCommercial />
      <div className="p-4 sm:ml-64 dark:bg-gray-900" style={{ paddingTop: '70px', minHeight: '100vh' }}>
        <Outlet />
      </div>
    </>
  );
};

export default CommercialLayout;